import { createUseStyles } from 'react-jss'

import { desktop, maxDesktop, notDesktop } from '../../theme'


export default createUseStyles({
  container: {
    display: 'flex',
    flexFlow: 'column nowrap',
    justifyContent: 'space-between',
    minHeight: 'calc(var(--vh, 1vh) * 50 - 2.2rem)', // 1/2 screen - half logo
    fallbacks: {
      minHeight: 'calc(50vh - 2.2rem)',
    },
    '& > *': {
      width: '100%',
      margin: 0,
    },
    '& > * + *': {
      marginTop: '2rem',
    },
    '& > * + $text': {
      marginTop: 'auto',
    },
    '& > *:not($text) + $nav': {
      marginTop: 'auto',
    },
    ...desktop({
      minHeight: 'calc(var(--vh, 1vh) * 50)', // 1/2 screen - half logo
      fallbacks: {
        minHeight: 'calc(50vh)',
      },
    }),
    ...maxDesktop({
      '& > * + $text:not(:last-child)': {
        marginBottom: '5rem', // added to avoid having the text stick to the nav....
      },
    }),
  },
  header: {},
  logo: {
    display: 'flex',
    justifyContent: 'center',
    marginbottom: '2rem',
  },
  logoGame: {
    display: 'flex',
    justifyContent: 'center',
    width: '25rem',
    height: '4.4rem',
    marginLeft: 'auto',
    marginRight: 'auto',
    '& svg': {
      width: '100%',
      height: 'auto',
    },
    ...desktop({
      width: '62.4rem',
      height: '10.9rem',
    }),
  },
  text: {
    maxWidth: '40rem',
    marginLeft: 'auto',
    marginRight: 'auto',
    minHeight: '8rem',
    fontSize: '1.2rem',
    lineHeight: '1.2',
    textAlign: 'center',
    '& > *': {
      margin: 0,
    },
    '& > * + *': {
      marginTop: '0.5rem',
    },
    ...notDesktop({
      '@media (orientation: landscape)': {
        minHeight: 0,
        marginTop: '2rem',
        marginBottom: '2rem',
      },
    }),
    ...desktop({
      '& > * + *': {
        marginTop: '1rem',
      },
    }),
  },
  nav: {},
})
